@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/border-width";

web-accordion {
    --background-color: #{color.$color-white};
    --border-color: #{color.$color-border};
    --border-width: #{border-width.$md};
    --border-color-top: var(--border-color);
    --border-width-top: var(--border-width);
    --border-radius: #{border-radius.$lg};
    --content-display: none;
    --heading-color: #{color.$color-text};
    --heading-font-family: #{font-family.$primary-regular};
    --heading-font-size: inherit;
    --heading-font-weight: normal;
    --pointer-events: auto;
    --icon-content-closed: "+";
    --icon-content-opened: "-";
    --icon-content: var(--icon-content-closed);
    --icon-color: #{color.$color-primary};
    --icon-display: initial;
    --icon-filter: none;
    --icon-font-size: 4rem;
    --icon-font-family: #{font-family.$handwritten};
    --icon-line-height: 1.5;
    --icon-height: 1.6rem;
    --icon-width: 1.6rem;

    &.is-open {
        --content-display: block;
        --icon-content: var(--icon-content-opened);
    }

    &[force-open="true"] {
        --pointer-events: none;
        --icon-content: "";
        --icon-display: none;
    }

    .accordion {
        background-color: var(--background-color);
        border: var(--border-width) solid var(--border-color);
        border-top-color: var(--border-color-top);
        border-top-width: var(--border-width-top);
        border-radius: var(--border-radius);
        color: var(--heading-color);
        height: 100%;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;

        .accordion-content {
            padding: 0 1.6rem 1.2rem 1.6rem;
            display: var(--content-display);
        }
    }

    button {
        border: none;
        background: none;
        color: inherit;
        font-family: var(--heading-font-family);
        font-size: var(--heading-font-size);
        font-weight: var(--heading-font-weight);
        text-align: left;
        cursor: pointer;
        padding: 1.4rem 1.6rem;
        margin: -0.2rem 0;
        display: flex;
        width: 100%;
        justify-content: space-between;
        pointer-events: var(--pointer-events);
        align-items: center;

        &:not(:has(web-icon)) {
            &::after {
                content: var(--icon-content);
                font-family: var(--icon-font-family);
                font-size: var(--icon-font-size);
                color: var(--icon-color);
                line-height: var(--icon-line-height);
                filter: var(--icon-filter);
                fill: var(--icon-color);
            }
        }

        web-icon {
            display: var(--icon-display);
            width: auto;

            &.accordion-icon-closed {
                color: var(--icon-color);
                justify-content: flex-start;
                svg {
                    height: var(--icon-height);
                    width: var(--icon-width);
                }
            }

            &.accordion-icon-opened {
                color: var(--icon-color);
                justify-content: flex-start;
                svg {
                    height: var(--icon-height);
                    width: var(--icon-width);
                }
            }
        }
    }
}
